// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"468bfd30","409":"6ba12192","591":"f9cc9faa"}[chunkId] + ".chunk.js";
};